"use client";

import { cn } from "@/src/lib/utils";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

interface ITocItem {
  id: string;
  text: string;
  level: 2 | 3;
}

export function DocsToc(props: { className?: string }) {
  const pathname = usePathname();
  const [items, setItems] = useState<ITocItem[]>([]);

  useEffect(() => {
    const article = document.getElementById("docs-article");
    if (!article) {
      setItems([]);
      return;
    }

    const headings = article.querySelectorAll("h2, h3");
    const nextItems: ITocItem[] = [];

    headings.forEach((heading) => {
      if (!(heading instanceof HTMLElement) || !heading.id) {
        return;
      }
      const level = heading.tagName === "H2" ? 2 : 3;
      nextItems.push({
        id: heading.id,
        text: heading.textContent?.trim() ?? "",
        level,
      });
    });

    setItems(nextItems);
  }, [pathname]);

  if (items.length === 0) {
    return null;
  }

  return (
    <nav className={cn("sticky top-6", props.className)}>
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-3">
        On this page
      </p>
      <ul className="flex flex-col gap-2 text-sm">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={cn(
                "text-muted-foreground hover:text-foreground transition-colors block",
                item.level === 3 && "pl-3"
              )}
            >
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
